module.exports = __webpack_public_path__ + "img/tempC.779e9d3a.png";